import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { IconSpriteModule } from '@personal-area/icon-sprite';

@Component({
  selector: 'icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, IconSpriteModule],
})
export class IconComponent {
  /**
   * Название иконки которую нужно вставить
   *
   * @type {string}
   * @memberof IconComponent
   */
  @Input() name!: string;
  /**
   * Путь до иконки или свг-картинки вне спрайта
   *
   * @type {string}
   * @memberof IconComponent
   */
  @Input() src!: string;
  /**
   * Цвет иконки
   * todo: не работает, когда вне спрайта
   *
   * @type {string}
   * @memberof IconComponent
   */
  @Input() color!: string;
  /**
   * Ширина
   *
   * @memberof IconComponent
   */
  @Input() width = '32px';
  /**
   * Высота
   *
   * @memberof IconComponent
   */
  @Input() height = '32px';
  @Input() viewBox = '0 0 32 32';
}
